import { Component, OnInit } from '@angular/core';

@Component({
	templateUrl: './error404.component.html',
	styleUrls: ['./error404.component.css'],
})
export class Error404Component implements OnInit {

	// Declare contructor
	constructor() { }

	// Declare initialization
	ngOnInit(): void {}
}
